export default __webpack_public_path__ + "static/media/property panel@2x.c4018339.png";